import React, { useState } from 'react';
import { Monitor, Smartphone, Tablet, ExternalLink, RefreshCw } from 'lucide-react';

const PreviewAdmin = () => {
  const [device, setDevice] = useState('desktop');
  const [key, setKey] = useState(0);

  const devices = [
    { id: 'desktop', icon: Monitor, label: 'Desktop', width: '100%' },
    { id: 'tablet', icon: Tablet, label: 'Tablet', width: '768px' },
    { id: 'mobile', icon: Smartphone, label: 'Mobile', width: '375px' },
  ];

  const currentDevice = devices.find(d => d.id === device);

  return (
    <div className="h-[calc(100vh-6rem)] flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-white">Preview do Portfolio</h1>
        <div className="flex items-center space-x-3">
          {/* Device selector */}
          <div className="flex bg-gray-800 rounded-lg p-1">
            {devices.map(d => (
              <button key={d.id} onClick={() => setDevice(d.id)}
                className={`p-2 rounded-md transition-colors ${device === d.id ? 'bg-lime-400 text-black' : 'text-gray-400 hover:text-white'}`}
                title={d.label}>
                <d.icon size={18} />
              </button>
            ))}
          </div>

          {/* Refresh */}
          <button onClick={() => setKey(k => k + 1)}
            className="p-2 text-gray-400 hover:text-lime-400 transition-colors" title="Recarregar">
            <RefreshCw size={18} />
          </button>

          {/* Open in new tab */}
          <a href="/" target="_blank" rel="noopener noreferrer"
            className="flex items-center space-x-2 px-3 py-2 bg-lime-400 text-black text-xs font-bold rounded-lg hover:bg-lime-300">
            <ExternalLink size={14} /><span>Abrir</span>
          </a>
        </div>
      </div>

      {/* Preview frame */}
      <div className="flex-1 bg-gray-950 border border-gray-800 rounded-2xl overflow-hidden flex items-start justify-center p-4">
        <div style={{ width: currentDevice.width, maxWidth: '100%', height: '100%' }}
          className="transition-all duration-300 bg-black rounded-xl overflow-hidden shadow-2xl border border-gray-800">
          <iframe
            key={key}
            src="/"
            title="Portfolio Preview"
            className="w-full h-full border-0"
            style={{ minHeight: '600px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default PreviewAdmin;
